import { createFileRoute } from "@tanstack/react-router";
import {
  ProposalSlideOver,
  ProposalSlideOverContent,
  ProposalSlideOverContentSkeleton,
  ProposalSlideOverNotFound,
} from "~/routes/(restricted)/byggeradar/-components/ProposalSlideOver";
import { useProposal } from "~/routes/(restricted)/byggeradar/-hooks/useProposal";
import { proposalSearchSchema } from "~/routes/(restricted)/byggeradar/-schemas/proposal-search";

export const Route = createFileRoute(
  "/(restricted)/byggeradar/_access/search/$proposalId",
)({
  component: RouteComponent,
  validateSearch: proposalSearchSchema,
  notFoundComponent: ProposalSlideOverNotFound,
});

function RouteComponent() {
  const { proposalId } = Route.useParams();
  const { isLoading, proposal, error } = useProposal(proposalId);

  return (
    <ProposalSlideOver>
      {error ? (
        <ProposalSlideOverNotFound />
      ) : !isLoading && proposal ? (
        <ProposalSlideOverContent
          proposalId={proposalId}
          proposal={proposal}
        />
      ) : (
        <ProposalSlideOverContentSkeleton />
      )}
    </ProposalSlideOver>
  );
}
